const eventAdded = {};

const addEventListeners = (elements) => {
  elements.forEach((el, i) => {
    if (eventAdded[i]) {
      return;
    }
    eventAdded[i] = true;
    el.addEventListener('mouseenter', (e) => {
      const dropdown = e.currentTarget.querySelector('.dropdown');
      const rect = dropdown.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        el.classList.add('left');
      } else {
        el.classList.remove('left');
      }
      delete eventAdded[i];
    }, { once: true });
  });
};

export const initDetectDropdownPositions = (targetEl) => {
  const target = targetEl || document;
  const buttonDropdowns = target.querySelectorAll('.button-list .has-dropdown');
  addEventListeners(buttonDropdowns);
  window.addEventListener('resize', () => {
    addEventListeners(buttonDropdowns);
  });
};
